<template>
    <div v-if="$store.state.connected">
        <Projet />
    </div>
</template>

<script>
    import Projet from "@/components/Manager/Projet.vue";
    import router from "../router/index.js";
    
    export default {
        name: "ProjetManager",
        data(){
            return{
            }
        },
        components: {
            Projet,
        },
        created: function() {
            if (!this.$store.state.connected) {
                router.push('connexion');
            } 
        }
    };
</script>